<script setup lang="ts">
withDefaults(defineProps<{ src: string | null; alt: string; fit?: 'cover' | 'contain' }>(), { fit: 'contain' })
</script>

<template>
  <div class="pimg">
    <img v-if="src" :src="src" :alt="alt" loading="lazy" :style="{ objectFit: fit }" />
    <div v-else class="pimg__placeholder" role="img" :aria-label="alt">
      <AppIcon name="image" :size="32" :stroke-width="1.5" />
    </div>
  </div>
</template>

<style scoped>
.pimg {
  width: 100%;
  height: 100%;
  background: var(--gray-50);
}

.pimg img {
  width: 100%;
  height: 100%;
}

.pimg__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--gray-400);
}
</style>
